import { isEmpty } from "@firebase/util";
import { collection, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

const getAllUserDocId = async () => {
  const userDocId = [];
  const data = await getDocs(collection(db, "Score2"));
  data.docs.map((item) => userDocId.push(item.id));
  return userDocId;
};

export const getAllScore = async (grade) => {
  let allUserId = await getAllUserDocId();
  const ScoreArray = [];
  for (let i = 0; i < allUserId.length; i++) {
    const scoreObject = await getDocs(
      collection(db, "Score2", allUserId[i], `Grade${grade}`, "week1", "round")
    );

    ScoreArray.push(scoreObject);
  }

  const AllScoresRound1 = ScoreArray.map((item) =>
    item.docs.filter((item2) => item2.id === "round1")
  );
  const AllUserScore = AllScoresRound1.map((item) =>
    item.map((item2) => item2.data().score)
  );

  // const ascending = AllUserScore.sort((a, b) => b - a);
  const valuesArray = [];
  for (let i = 0; i < AllUserScore.length; i++) {
    if (!isEmpty(AllUserScore[i])) {
      valuesArray.push(AllUserScore[i]);
    }
  }
  const convertData = valuesArray.map((item) => {
    return { score: item };
  });
  return convertData;
};

export const SubmitScore = async (data, userName) => {
  return setDoc(doc(db, "Score", userName), data);
};

export const SubmitScore2 = async (data, userName, round, grade, week) => {
  const addField = await setDoc(doc(db, "Score2", userName), {
    name: userName,
  }).then((res) => {
    setDoc(
      doc(
        db,
        "Score2",
        userName,
        `Grade${grade}`,
        `week${week}`,
        "round",
        `round${round}`
      ),
      data
    );
  });
  return addField;
};
